import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Collapse } from "reactstrap"
import { withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

import newStore from "newStore"
import userStore from "userStore"

import NavbarItems from "./NavbarItems"

const Navbar = props => {
  const navbar = newStore(state => state.navbar)
  const admin = userStore(state => state.admin)

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    for (var i = 0; i < items.length; ++i) {
      if (props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [])

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  const toggleTodo = order => {
    const newNavbarRoutes = [...navbar]
    newNavbarRoutes.map(item => {
      if (item.order === order) {
        item.show = !item.show
      }
      return item
    })
    newStore.setState({ navbar: newNavbarRoutes })
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMen}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                {navbar
                  // .filter(item => item.admin === admin)
                  .map((item, key) => (
                    <li className="nav-item dropdown" key={key}>
                      <NavbarItems
                        item={item}
                        admin={admin}
                        toggleTodo={toggleTodo}
                        dropdown="nav-link"
                        // pathnameChange={pathnameChange}
                        {...props}
                      />
                    </li>
                  ))}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(Navbar))
